<main class="voucher-page">

  <!-- Chargement -->
  @if (loading) {
    <div class="voucher-skeleton">
      <p-skeleton borderRadius="8px" height="2rem" width="20%" styleClass="mb-2"></p-skeleton>
      <p-skeleton borderRadius="8px" height="1rem" width="50%"></p-skeleton>
      <p-skeleton borderRadius="16px" height="16rem" styleClass="mt-4"></p-skeleton>
    </div>
  }

  <!-- Erreur -->
  @if (!loading && error) {
    <div class="voucher-error">
      <p class="voucher-error-message">{{ 'voucher.error' | translate }}</p>
    </div>
  }

  <!-- Contenu -->
  @if (!loading && !error && voucher) {

    <!-- Nom du bon de réduction -->
    <h1 class="voucher-name">{{ voucher.name }}</h1>

    <!-- Date de fin de validité -->
    @if (formattedEndDate) {
      <p class="voucher-validity">
        {{ 'voucher.validity' | translate: { date: formattedEndDate } }}
      </p>
    }

    <!-- Séparateur -->
    <hr class="voucher-divider" />

    <!-- Code barre à faire scanner en caisse -->
    <section class="voucher-qr-section">
      <p class="voucher-qr-label">{{ 'voucher.qr-label' | translate }}</p>
      <svg #barcode class="barcode sentry-mask"></svg>
      <p class="voucher-code sentry-mask">{{ code }}</p>
    </section>
  }

</main>
